@let readableNumber = readableNumberSg();
@let isOverflowing = isOverflowingSg();
@let overflowPlaceholder = overflowPlaceholderSg();

<!-- Adding position: absolute to #hidden div so that it doesn't take up the
space of the #number div. This also means that we have to use clientWidth from
the #number div since it's the only one that can overflow -->
<div
  #hidden
  class="atn-number-content__hidden"
>
  {{ readableNumber }}
</div>
<div #number>
  {{ isOverflowing ? overflowPlaceholder : readableNumber }}
</div>
